import React, { useEffect, useState } from "react";
import {
  Layout,
  PageHeader,
  Button,
  Divider,
  Row, Col, Space, Card, Avatar, Empty, Radio
} from "antd";
import { useSelector } from "react-redux";
import Spinner from "../../components/Layout/Spinner";
import "./style.scss";
import OverviewCard from "../../components/Card/OverviewCard";
import { Doughnut } from 'react-chartjs-2';
import { Line } from "react-chartjs-2";
import DashboardService from "../../services/DashboardService";
import RatingLayout from "../../components/Layout/RatingLayout";
import moment from "moment"
import { DownloadCsv } from "../Business/Customers/downloadCsv";
import { getLocalISODate } from "../../utils";
import { Typography } from "antd";

const { Text } = Typography;


const { Content } = Layout;

const PosDashBoard = () => {
  const adminRestaurant = useSelector((state) => state.admin);
  const [dashboardKpi, setDashboardKpi] = useState();
  const [dashboardKpiWeekly, setDashboardKpiWeekly] = useState();
  const [dashboardKpiMonthly, setDashboardKpiMonthly] = useState();
  const [isLoading, setLoading] = useState(false);

  const [salesDate, setSalesDate] = useState();
  const [salesOverview, setSalesOverview] = useState();
  const [profitsOverview, setProfitsOverview] = useState();
  const [salesItem, setSalesItem] = useState();
  const [sizeCat, setSizeCat] = useState('daily');
  const [sizeMenu, setSizeMenu] = useState('daily');
  const [sizeOverview, setSizeOverview] = useState('daily');
  const [profitSizeOverview, setProfitSizeOverview] = useState('daily');




  const changeDate=(value,type)=>{
    switch (type)
    {
      case "category":
        setSizeCat(value);
        const fields = value == 'daily'? dashboardKpi : value == 'weekly' ?dashboardKpiWeekly: dashboardKpiMonthly;
        if (fields && fields.sales_by_category && fields.sales_by_category?.length>0) {
          const data = {
            labels: fields.sales_by_category?.map(item => item.category),
            datasets: [
              {
                data: fields.sales_by_category?.map(item => item.sales),
                backgroundColor: ["#FF94C1", "#DB0404", "#FF5E71"],
                borderColor: ["#FF94C1", "#DB0404", "#FF5E71"],
                borderWidth: 1,
              },
            ],
          };
          setSalesDate(data)
    
        }else
        setSalesDate(undefined)
        break
        case "menu":
        setSizeMenu(value);
        const fieldsMenu = value == 'daily'? dashboardKpi : value == 'weekly' ?dashboardKpiWeekly: dashboardKpiMonthly;

        if (fieldsMenu && fieldsMenu.sales_by_menu_section && fieldsMenu.sales_by_menu_section?.length>0) {
          const data = {
            labels: fieldsMenu.sales_by_menu_section?.map(item => item.menu_section),
            datasets: [
              {
                data: fieldsMenu.sales_by_menu_section?.map(item => item.sales),
                backgroundColor: ["#FF94C1", "#DB0404", "#FF5E71",
                  "#FF94b2", "#DB0505", "#FF5F72"
                ],
                borderColor: ["#FF94C1", "#DB0404", "#FF5E71",
                  "#FF94b2", "#DB0505", "#FF5F72"
                ],
                borderWidth: 1,
              },
            ],
          };
          setSalesItem(data)
    
        }
        else
        setSalesItem(undefined)
        break

        case "overview":
        setSizeOverview(value);
        const fieldsOverview = value == 'daily'? dashboardKpi : value == 'weekly' ?dashboardKpiWeekly: dashboardKpiMonthly;

        if (fieldsOverview && fieldsOverview?.sales_overview && fieldsOverview?.sales_overview?.length>0) {
          const Data = fieldsOverview?.sales_overview?.map((item, index) => {
            return {
              id: index,
              year:  moment(item.timestamp).format("MM/DD/yyyy") ,
              userGain: item.sales
            }
          }
          )
    
    
          setSalesOverview({
            labels: Data.map((data) => data.year),
            datasets: [
              {
                label: "Sales ",
                data: Data.map((data) => data.userGain),
                backgroundColor: [
                  "rgba(75,192,192,1)",
                  // &quot;#ecf0f1",
                  "#50AF95",
                  "#f3ba2f",
                  "#2a71d0"
                ],
                borderColor: "black",
                borderWidth: 2
              }
            ]
          });
        }
        else
        setSalesOverview(undefined)
        break

        case "profit":
        setProfitSizeOverview(value);
        const fieldsProfiOverview = value == 'daily'? dashboardKpi : value == 'weekly' ?dashboardKpiWeekly: dashboardKpiMonthly;

        if (fieldsProfiOverview && fieldsProfiOverview?.sales_overview && fieldsProfiOverview?.sales_overview?.length>0) {
          const Data = fieldsProfiOverview?.sales_overview?.map((item, index) => {
            return {
              id: index,
              year:  moment(item.timestamp).format("MM/DD/yyyy") ,
              userGain: item.sales
            }
          }
          )
    
    
          setProfitsOverview({
            labels: Data.map((data) => data.year),
            datasets: [
              {
                label: "Sales ",
                data: Data.map((data) => data.userGain),
                backgroundColor: [
                  "rgba(75,192,192,1)",
                  // &quot;#ecf0f1",
                  "#50AF95",
                  "#f3ba2f",
                  "#2a71d0"
                ],
                borderColor: "black",
                borderWidth: 2
              }
            ]
          });
        }
        else
        setProfitsOverview(undefined)
        break

      



    }
  

  }


  useEffect(() => {
    getDashboard();
    // return () => {
    //     cleanup
    // }
  }, [adminRestaurant])

  const getDashboard = async () => {
    setLoading(true)
    const posKpi = await DashboardService.getPosKpi( new Date().toISOString().slice(0, 10));
    const posKpiWeekly = await DashboardService.getPosKpiTime(moment(moment().add(-7, 'days')).format("YYYY-MM-DD"), new Date().toISOString().slice(0, 10));
    const posKpiMonthly = await DashboardService.getPosKpiTime( moment(moment().add(-30, 'days')).format("YYYY-MM-DD"),new Date().toISOString().slice(0, 10));

    setDashboardKpi(posKpi)
    setDashboardKpiMonthly(posKpiMonthly)
    setDashboardKpiWeekly(posKpiWeekly)
    setLoading(false)

   
    

  }

  useEffect(()=>{
    changeDate('daily',"category")
    changeDate('daily',"menu")
    changeDate('daily',"overview")
  },[dashboardKpi])

 

 

  const options = {
    responsive: true,
    maintainAspectRatio:false,
                    defaultFontSize:"14px",
                    width:"300",
                    height:"300",
    plugins: {
      legend: {
        position: "bottom",
        align: "center",
        labels: {
          boxWidth: 40,
          useBorderRadius: true,
          borderRadius: 40,
          usePointStyle: true,
        },
      },
    },
  };

  const getColor = (rating) => {
    switch (rating) {
      case 1:
        return "#BD1B04"
      case 2:
        return "#BD5204"
      case 3:
        return "#D7C200"
      case 4:
        return "#8DA400"
      case 5:
        return "#0B8617"
      default:
        return "#0B8617"
    }
  }

  const exportCsv = async () => {
    const data =await DashboardService.getPosOrder();

    DownloadCsv(data,"Pos.csv",true);
  };

  
  

  return (
    <Layout className="u-page-layout tips-layout delivery-layout">

      <Content className="w-full page-padding">
        <Space direction="vertical" style={{ width: "100%" }}>
          <PageHeader
            title={
              <Text className="responsive-text">Table Status ({getLocalISODate()})</Text>}
            className="page-header"
            extra={[
              <div>

                <Button type="primary"
                 onClick={() => {
                  exportCsv();
                }}
                >Export</Button>


              </div>,
            ]}
          />
          <Row className="text-left tips-card-margin" gutter={[16, 16]}>
            <Col >
              <OverviewCard title={dashboardKpi?.total_tables_served_today} subTitle="Total tables Served today" />
            </Col>
            <Col >
              <OverviewCard title={dashboardKpi?.table_with_unassigned_servers} subTitle="Tables with unassigned Servers" />
            </Col>
            <Col >
              <OverviewCard title={dashboardKpi?.tables_currently_unoccupied} subTitle="Tables currently unoccupied" />
            </Col>
            <Col >
              <OverviewCard title={dashboardKpi?.tables_reserved_online} subTitle="Tables reserved online" />
            </Col>
          </Row>
          <Divider />

          <PageHeader
            title={`Staff`}
            className="page-header"
            extra={[
              <div>


              </div>,
            ]}
          />
           {dashboardKpi &&
          <Row className="text-left tips-card-margin" gutter={[16, 16]}>
            <Col >
              <OverviewCard title={dashboardKpi?.total_servers} subTitle="Total Servers" />
            </Col>
            <Col >
              <OverviewCard title={dashboardKpi?.total_servers_on_duty} subTitle="Servers on duty" />
            </Col>
            <Col >
              <OverviewCard title={dashboardKpi?.total_other_staff_on_duty} subTitle="Other staff on duty" />
            </Col>
            <Col >
              <OverviewCard title={dashboardKpi?.total_tip_received+""} subTitle="Tips recieved" />
            </Col>
          </Row>
}
          <Divider />

          <PageHeader
            title={`Sales by Catering`}
            className="page-header"
            extra={[
              <div>



              </div>,
            ]}
          />
          {dashboardKpi &&
          <Row className="text-left tips-card-margin" gutter={[16, 16]}>
            <Col >
              <OverviewCard title={"$" + dashboardKpi?.sales_today+""} subTitle="Sales today" />
            </Col>
            <Col >
              <OverviewCard title={"$" + dashboardKpi?.sales_week+""} subTitle="Sales this week" />
            </Col>
            <Col >
              <OverviewCard title={"$" + dashboardKpi?.sales_month} subTitle="Sales this month" />
            </Col>
            <Col >
              <OverviewCard title={"$" + dashboardKpi?.sales_ytd} subTitle="Sales YTD" />
            </Col>
          </Row>
}
          <Divider />

          <PageHeader
            title="KPIs"
            className="page-header"

          />

          <Row className="text-left tips-card-margin" gutter={[16, 16]}>
            <Col xs={24} md={11} lg={11}>

              <Card
                title={<PageHeader
                  title="Sales by category"
                  className="page-header"
                  extra={[
                    <div>
                      <Radio.Group value={sizeCat} onChange={(e) => changeDate(e.target.value,"category")}>
                        <Radio.Button value="daily">Daily</Radio.Button>
                        <Radio.Button value="weekly">Weekly</Radio.Button>
                        <Radio.Button value="monthly">Monthly</Radio.Button>
                      </Radio.Group>

                    </div>,
                  ]}
                />}
                bordered={false}
                style={{
                  width: "100%",
                  height: "100%"
                }}
              >
                <div style={{
                  display: "flex",
                  justifyContent: "center"
                }}>
                  {salesDate ?
                   <div style={{ width: '700px', height: '400px', padding:"30px" }}>
                    <Doughnut data={salesDate} options={options} />
                    </div>:
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                </div>
              </Card>
            </Col>
            <Col xs={24} md={2}  lg={2} style={{ textAlign: "center" }}>
              <Divider type="vertical" />
            </Col>
            <Col xs={24} md={11} lg={11}>

              <Card
                title={<PageHeader
                  title="Sales by menu selection"
                  className="page-header"
                  extra={[
                    <div>
                      <Radio.Group value={sizeMenu} onChange={(e) => changeDate(e.target.value,"menu")}>
                        <Radio.Button value="daily">Daily</Radio.Button>
                        <Radio.Button value="weekly">Weekly</Radio.Button>
                        <Radio.Button value="monthly">Monthly</Radio.Button>
                      </Radio.Group>

                    </div>,
                  ]}
                />}
                bordered={false}
                style={{
                  width: "100%",
                  height: "100%"
                }}
              >
                <div style={{
                  display: "flex",
                  justifyContent: "center"
                }}>
                  {salesItem ?
                   <div style={{ width: '700px', height: '400px', padding:"30px" }}>
                    <Doughnut data={salesItem} options={options} />
                    </div>
                    :
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                </div>
              </Card>
            </Col>
          </Row>

          <Row className="text-left tips-card-margin" gutter={[16, 16]}>
            <Col xs={24} md={11} lg={11}>

              <Card
                title={<PageHeader
                  title="Sales overview"
                  className="page-header"
                  extra={[
                    <div>
                      <Radio.Group value={sizeOverview} onChange={(e) => changeDate(e.target.value,"overview")}>
                        <Radio.Button value="daily">Daily</Radio.Button>
                        <Radio.Button value="weekly">Weekly</Radio.Button>
                        <Radio.Button value="monthly">Monthly</Radio.Button>
                      </Radio.Group>

                    </div>,
                  ]}
                />}
                bordered={false}
                style={{
                  width: "100%",
                  height: "100%"
                }}
              >
                <div>
                  {salesOverview ?
                    <Line
                      data={salesOverview}
                      options={{
                        plugins: {
                          title: {
                            display: true,
                            text: "Users Gained between 2016-2020"
                          },
                          legend: {
                            display: false
                          }
                        }
                      }}
                    />
                    :
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                </div>
              </Card>
            </Col>
            <Col xs={24} md={2}  lg={2} style={{ textAlign: "center" }}>
              <Divider type="vertical" />
            </Col>
            <Col xs={24} md={11} lg={11} >

              <Card
                title="Popular items"
                bordered={false}
                style={{
                  width: "100%",
                  height: "100%"
                }}
              >
                <div>
                  {dashboardKpi?.popular_items && dashboardKpi?.popular_items?.length > 0 ?
                    dashboardKpi?.popular_items?.map(item =>
                      <div className="delivery-card-items">
                        <div className="flex">
                          <Avatar size={70} src={item.item_photo}
                            style={{ marginRight: "20px" }} />
                          <div >
                            <div className="item-name">{item.item_name}</div>
                            <div className="item-units"> Units Sold: <span className="unit">{item.total_quantity}</span></div>
                          </div>
                        </div>
                        <div className="item-price">
                          $ {item.price}

                        </div>
                      </div>) :
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                </div>
              </Card>
            </Col>
          </Row>
          <Row className="text-left tips-card-margin" gutter={[16, 16]}>
          <Col xs={24} md={11} lg={11}>

              <Card
                title={<PageHeader
                  title="Profits overview"
                  className="page-header"
                  extra={[
                    <div>
                      <Radio.Group value={profitSizeOverview} onChange={(e) => changeDate(e.target.value,"profit")}>
                        <Radio.Button value="daily">Daily</Radio.Button>
                        <Radio.Button value="weekly">Weekly</Radio.Button>
                        <Radio.Button value="monthly">Monthly</Radio.Button>
                      </Radio.Group>

                    </div>,
                  ]}
                />}
                bordered={false}
                style={{
                  width: "100%",
                  height: "100%"
                }}
              >
                <div>
                  {profitsOverview ?
                    <Line
                      data={profitsOverview}
                      options={{
                        plugins: {
                          title: {
                            display: true,
                            text: "Users Gained between 2016-2020"
                          },
                          legend: {
                            display: false
                          }
                        }
                      }}
                    />
                    :
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                </div>
              </Card>
            </Col>
            <Col xs={24} md={2}  lg={2} style={{ textAlign: "center" }}>
              <Divider type="vertical" />
            </Col>
           
            <Col xs={24} md={11} lg={11}>

              <Card
                title="Top rated servers"
                bordered={false}
                style={{
                  width: "100%",
                  height: "100%"
                }}
              >
                <div>
                  {dashboardKpi?.top_rated_servers && dashboardKpi?.top_rated_servers?.length > 0 ?
                    dashboardKpi?.top_rated_servers?.map(item =>
                      <div className="delivery-card-items">
                        <div className="flex">
                          <Avatar size={70} src={item.photo_url}
                            style={{ marginRight: "20px" }} />
                          <div >
                            <div className="item-name">{item.name}</div>
                            <div className="item-units"> Tables served: <span className="unit">{item.rating_count}</span></div>
                          </div>
                        </div>
                        <div className="item-price">
                          <RatingLayout rating={item.rating} color={getColor(item.rating)} />

                        </div>
                      </div>) :
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                </div>
              </Card>
            </Col>
          </Row>
        </Space>
      </Content>
      {isLoading &&
      <Spinner/>
}
    </Layout>
  );
};

export default PosDashBoard;
